
import mapboxgl from 'mapbox-gl';
import { getNeighborhoodDisplay } from '@/utils/neighborhoodFormatting';
import type { RestaurantWithEventSpaces } from '@/types/restaurant';

export const createMapMarker = (
  restaurant: RestaurantWithEventSpaces,
  map: mapboxgl.Map,
  coordinates: [number, number]
): mapboxgl.Marker => {
  // Validate coordinates
  if (!coordinates || coordinates.length !== 2 || coordinates.some(coord => typeof coord !== 'number' || isNaN(coord))) {
    console.error('Invalid coordinates for restaurant:', restaurant.name);
    throw new Error('Invalid coordinates format');
  }

  // Extract just the street address and zip code
  const formattedAddress = restaurant.address?.replace(/,.+(\d{5}).*$/, ', $1')
    .replace(/, United States$/, '')
    .replace(/, New York, New York/, '')
    .replace(/, New York, NY/, '')
    .replace(/, New York$/, '');
  
  // Create and configure popup
  const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
    <div class="p-3 max-w-[240px]">
      <div class="space-y-2">
        <div>
          <h3 class="font-semibold text-primary mb-1">${restaurant.name}</h3>
          <p class="text-xs text-gray-600">${formattedAddress}</p>
        </div>
        
        ${restaurant.eventspaces?.length ? `
          <div class="text-sm text-primary font-medium">
            ${restaurant.eventspaces.length} Private Space${restaurant.eventspaces.length > 1 ? 's' : ''}
          </div>
        ` : ''}
        
        <button
          onclick="window.history.pushState({}, '', '/restaurant/${restaurant.id}'); window.dispatchEvent(new PopStateEvent('popstate'));"
          class="w-full bg-primary text-primary-foreground px-3 py-1.5 rounded-md text-sm hover:bg-primary/90 transition-colors flex items-center justify-center gap-2 group"
        >
          View Spaces
          <svg class="w-3 h-3 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  `);

  // Create and configure marker
  const marker = new mapboxgl.Marker({
    color: '#222222',
    scale: 0.9,
    anchor: 'bottom',
  })
    .setLngLat(coordinates)
    .setPopup(popup)
    .addTo(map);

  return marker;
};
